import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-primary-950 text-foreground-800">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className="ri-play-circle-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">成人快手</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-700">
              面向 18 岁以上成年用户的短视频娱乐平台，汇聚生活、娱乐、兴趣等多领域内容，专注优质的浏览与分享体验。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-950">
              <a href="#site-nav">网站导航</a>
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-foreground-700 transition-colors hover:text-accent-300">首页</Link></li>
              <li><Link to="/search" className="text-foreground-700 transition-colors hover:text-accent-300">搜索</Link></li>
              <li><Link to="/favorites" className="text-foreground-700 transition-colors hover:text-accent-300">我的收藏</Link></li>
              <li><Link to="/about" className="text-foreground-700 transition-colors hover:text-accent-300">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-950">
              <a href="#category">热门分类</a>
            </h4>
            <ul className="space-y-3 text-sm">
              {categories.slice(0, 4).map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-foreground-700 transition-colors hover:text-accent-300">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-950">
              <a href="#more">更多分类</a>
            </h4>
            <ul className="space-y-3 text-sm">
              {categories.slice(4).map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-foreground-700 transition-colors hover:text-accent-300">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center">
          <p>© {year} 成人快手 · 本站为内容演示站点，所有视频均为展示用途。</p>
          <p className="flex items-center gap-1">
            <i className="ri-shield-check-line text-accent-400" />
            仅面向 18 周岁及以上用户
          </p>
        </div>
      </div>
    </footer>
  );
}